export const enum EResultadoEnvioConfide {
  ENVIADO = 'Enviado',
  DESOBRIGADO = 'Desobrigado'
}

export const enum EStatusRelatorioConfide {
  PENDENTE_RECEBIMENTO = 'Pendente de Recebimento',
  ACOMPANHAMENTO_DO_PROCESSO = 'Acompanhamento do Processo',
  RECEBIDO = 'Recebido',
  ENVIADO = 'Enviado',
}

export const enum EStatusSolicitacaoAvaliacaoFinanceira {
  PENDENTE_RECEBIMENTO = 'Pendente de Recebimento',
  PENDENTE_ENVIO = 'Pendente de Envio',
  RECEBIDO = 'Recebido',
  ENVIADO = 'Enviado',
}

export const enum EStatusCadastroResultadoAvaliacaoFinanceira {
  PENDENTE = 'Pendente',
  RECEBIDO = 'Recebido',
}